import { AvgVideosReviewedGraph } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/AvgVideosReviewed/AvgVideosReviewedGraph";
import { AvgVideosReviewedRawData } from "@pages/VideoAnalytics/BCBAs/GraphAndRawData/AvgVideosReviewed/AvgVideosReviewedRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface AvgVideosReviewedProps {
  avgVideosReviewed: boolean;
}
export const AvgVideosReviewed: React.FC<AvgVideosReviewedProps> = ({ avgVideosReviewed }) => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>
      {selectedDialogTab === "Raw Data" ? (
        <AvgVideosReviewedRawData avgVideosReviewed={avgVideosReviewed} />
      ) : (
        <AvgVideosReviewedGraph />
      )}
    </div>
  );
};
